import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { BaseTypographyComponent } from '../base-typography.component';

@Component({
  selector: 'app-h1',
  template: '<h1 class="{{ngClass}}"><ng-content></ng-content></h1>',
  styleUrls: ['./h1.component.scss'],
  standalone: true,
  imports: [
    CommonModule
  ]
})
export class H1Component extends BaseTypographyComponent{
}
